var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"rgba(4, 49, 100, .6)"},attrs:{"id":_vm.mapJson.mapName}})
}
var staticRenderFns = []

export { render, staticRenderFns }